import { Link, useLocation } from "react-router-dom";
import { textChooser } from "../../util/textChooser";
import { Logo } from "../logo";
import "./header.scss";

export default function PublicHeader() {
  const { pathname } = useLocation();

  return (
    <header data-testid="no-logged-header" className="header">
      <div className="left-col">
        <Link to="/" className="link-homepage">
          <Logo />
        </Link>
      </div>

      <div className="right-col">
        <Link to="/login" className="link-auth text sizeSm white">
          {textChooser("txt1")}
        </Link>
        <Link to={`/register?ref=${pathname}`} className="link-auth text sizeSm colorWhite">
          {textChooser("txt200")}
        </Link>
      </div>
    </header>
  );
}